import { isPartOfMegaMenu } from './descriptor.is-part-of-megamenu.js';
import { findPageDescriptorByPath } from './util.find-page-descriptor-by-path.js';

function findRenderedDescriptorByPath(state, path) {
  const pageDescriptor = findPageDescriptorByPath(state, path);
  if (pageDescriptor && isPartOfMegaMenu(state, pageDescriptor)) {
    return findPageDescriptorByPath(state, "/");
  }
  return pageDescriptor;
}

export { findRenderedDescriptorByPath };
//# sourceMappingURL=path.find-rendered-descriptor.js.map
